import { type Ref, readonly, ref, watch } from 'vue'

export const useVideoControls = (
  videoRef: Ref<HTMLVideoElement | null>,
  props: { isActive: boolean; play: boolean },
  emit: ((evt: 'play', args_0: void) => void) &
    ((evt: 'pause', args_0: void) => void)
) => {
  const isPlaying = ref(false)

  const playVideo = () => {
    if (videoRef.value) {
      videoRef.value.play()
      isPlaying.value = true
      emit('play')
    }
  }

  const pauseVideo = () => {
    if (videoRef.value) {
      videoRef.value.pause()
      isPlaying.value = false
      emit('pause')
    }
  }

  const playPauseVideo = () => {
    if (videoRef.value?.paused) {
      playVideo()

      return
    }

    pauseVideo()
  }

  const rewindVideo = () => {
    pauseVideo()

    if (videoRef.value) {
      videoRef.value.currentTime = 0
    }
  }

  watch(
    () => props.isActive,
    (value) => {
      if (!value) {
        rewindVideo()
      } else {
        playVideo()
      }
    }
  )

  watch(
    () => props.play,
    (value) => {
      if (value) {
        playVideo()
      } else {
        pauseVideo()
      }
    }
  )

  return {
    playVideo,
    pauseVideo,
    playPauseVideo,
    rewindVideo,
    isPlaying: readonly(isPlaying),
  }
}
